<template>
  <div>
    <div class="note-item" style="margin-top: 30px">
      <div class="note-title-wrap">
        <div class="note-title">カスタマイズタグ</div>
        <div class="flex-space"></div>
        <el-button size="mini" @click="openEditTagDrawer()">
          <font-awesome-icon :icon="['far', 'cog']" style="margin-right: 3px;" />
          タグを管理</el-button
        >
      </div>
      <customizeTag :id="id" :sns_type="sns_type" :tags="tags" ref="customizeTag" :parent_component="'note'" @updateTag="updateTag"/>
    </div>

    <customizeTagDrawer :drawer="drawer" @closeDrawer="closeEditTagDrawer" @updateReactive="updateReactive" />
  </div>
</template>

<script>
import customizeTag from "./customize_tag.vue";
import customizeTagDrawer from "./customize_tag_drawer.vue";

export default {
  name: "NoteCustomizeTag",
  components: {
    customizeTag,
    customizeTagDrawer,
  },
  props: {
    id: { type: String, required: true },
    sns_type: { type: String, required: true },
    tags: { type: Array },
  },
  data() {
    return {
      drawer: false,
      input: false,
      new_tag: "",
      suggest_tag: false,
      suggest_on: false,
      suggest_hover: -1,
      suggest_loading: false,
      tag_list: [],
      requestId: +new Date(),
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.note.edit;
    },
  },
  mounted() {},
  methods: {
    openEditTagDrawer() {
      if (this.permission) {
        this.drawer = true;
        document.documentElement.style.overflow = "hidden";
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    closeEditTagDrawer() {
      this.drawer = false;
      document.documentElement.style.overflow = "auto";
    },
    updateReactive(type, tag_id, value) {
      this.$refs.customizeTag.updateReactive(type, tag_id, value);
    },
    updateTag(type, tag_index, new_tag) {
      this.$emit("updateTag", type, tag_index, new_tag);
    },
  },
  watch: {},
};
</script>
